// "Erste Schritte"-Checkliste — Haekchen kommen AUSSCHLIESSLICH aus echtem Zustand (ECHT-Mandat).
// Kein Fake-Tracking: 2FA wirklich aktiv, Website wirklich geprueft, keine offene Freigabe mehr.
export function buildChecklist({ user = {}, overview = {} }) {
  const website = overview.website || {};
  return [
    { key: "tour", label: "Cockpit-Rundgang abgeschlossen", done: !!user.onboarding_completed_at, to: null },
    { key: "2fa", label: "Konto mit 2FA schützen", done: !!user.totp_enabled, to: "security", cta: "2FA aktivieren" },
    { key: "website", label: "Ihre Website prüfen", done: !!website.last_checked, to: "website", cta: "Jetzt prüfen" },
    { key: "approval", label: "Offene Freigabe erteilen", done: (overview.pending_tasks || 0) === 0, to: "tasks", cta: "Zu den Freigaben" },
  ].filter(item => user.role !== "client_staff" || !item.to || item.to === "security" || (Array.isArray(user.allowed_sections) && user.allowed_sections.includes(item.to)));
}
